<div id="extra-info-container" class="top" [ngStyle]="getPanelStyle()" (click)="$event.stopPropagation()">
  <svg class="icon-close-msg" (click)="cerrar()">
    <use xlink:href="#icon-close"></use>
  </svg>
  <div class="extra-info-content">

    <form *ngIf="data.tipoInfo === 'casillas'" [formGroup]="extraInfoCasillasCamposService.formularioCasillas">
      <label>Orden de la opción</label>
      <input type="number" min="1" formControlName="ordenOpcion" [ngClass]="isCampoValido('ordenOpcion', data.tipoInfo) ? 'errorInput':'' " style="margin-top: -5px;">
      <span class="texto-validacion" *ngIf="isCampoValido('ordenOpcion', data.tipoInfo)">{{mensajeErrorOrdenOpcion}}</span>
      <label class="label-con-ayuda">
        Valor opción seleccionada
        <span class="ayuda-tooltip tooltip">
          <svg class="icon-help" aria-hidden="true" viewBox="0 0 22 22" fill="none">
            <path
              d="M8.09 8C8.3251 7.33167 8.78915 6.76811 9.39995 6.40913C10.0108 6.05016 10.7289 5.91894 11.4272 6.03871C12.1255 6.15849 12.7588 6.52152 13.2151 7.06353C13.6713 7.60553 13.9211 8.29152 13.92 9C13.92 11 10.92 12 10.92 12M11 12.5V14.5M11 16.25H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <app-tooltip-sqp
            [textoTooltip]="'Valor que elige el firmante y que se muestra al descargar el Excel de formularios en Gestión de envíos.'"
            [posicion]="'right'">
          </app-tooltip-sqp>
        </span>
      </label>
      <input type="text" formControlName="valorOpcionSeleccionada" style="margin-top: -5px;">
    </form>

    <form *ngIf="data.tipoInfo === 'campos'" [formGroup]="extraInfoCasillasCamposService.formularioCampos">
      <label>Identificador</label>
      <input type="text" formControlName="identificadorCampo" [readonly]="true" class="readonly-input" [ngClass]="isCampoValido('identificadorCampo', data.tipoInfo) ? 'errorInput':'' " style="margin-top: -5px;">
      <span class="texto-validacion" *ngIf="isCampoValido('identificadorCampo', data.tipoInfo)">{{mensajeErrorIdentificadorCampo}}</span>
      <label>Nombre del campo</label>
      <input type="text" formControlName="nombreCampo" style="margin-top: -5px;">
      <label>Valor defecto</label>
      <app-drop-down-single-con-id  [data]="palabrasClave"
                                    [valorPreSeleccionado]="valorPorDefecto.value"
                                    [width]="'250px'"
                                    [height]="'34px'"
                                    [tituloArriba]="false"
                                    [maxHeight]="'150px'"
                                    [errorClass]="isCampoValido('valorPorDefecto', data.tipoInfo) ? 'errorInput' : ''"
                                    (elementoSeleccionado)="seleccionarValorPorDefecto($event)"
                                    style="margin-top: -5px;">
      </app-drop-down-single-con-id>
      <!-- <input type="hidden" formControlName="valorPorDefecto"> -->
      <span class="texto-validacion" *ngIf="isCampoValido('valorPorDefecto', data.tipoInfo)">{{mensajeErrorValorPorDefecto}}</span>
      <div class="checkbox-container">
        <input type="checkbox" formControlName="obligatorio">
        <label>Obligatorio</label>
      </div>
    </form>
    <form *ngIf="data.tipoInfo === 'palabras'" [formGroup]="extraInfoCasillasCamposService.formularioPalabras">
      <label>Identificador</label>
      <input type="text" formControlName="identificadorPalabra" [readonly]="true" class="readonly-input" [ngClass]="isCampoValido('identificadorPalabra', data.tipoInfo) ? 'errorInput':'' " style="margin-top: -5px;">
      <span class="texto-validacion" *ngIf="isCampoValido('identificadorPalabra', data.tipoInfo)">{{mensajeErrorIdentificadorPalabra}}</span>
      <label>Nombre del campo</label>
      <input type="text" formControlName="nombrePalabra" style="margin-top: -5px;">
    </form>
  </div>

  <div class="modal-buttons-msg">
    <app-boton-accion style="margin-left: -10px;" [icono]="'hs-bin'" [id]="'borrar'" [outlineRed]="true" [disabled]="!permitirBorrado" (click)="borrarCasilla()"></app-boton-accion>
    <div>
      <app-boton-accion (click)="cerrar()" [id]="'cancelar'" [titulo]="'cancelar'" [outline]="true" [cancelar]="true"></app-boton-accion>
      <app-boton-accion (click)="guardarInfoExtra()" [id]="'aceptar'" [titulo]="'Aceptar'"></app-boton-accion>
    </div>
  </div>
  <i></i>
</div>
